import { Component, HostListener } from '@angular/core';
import { GlobalService } from '../services/global.service';
import * as Highcharts from 'highcharts';

@Component({
  selector: 'app-main',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.scss']
})
export class MainComponent {

  constructor(public globalService: GlobalService) { }
  @HostListener('window:resize', ['$event'])
  onResize(event) {
    setTimeout(function () {
      Highcharts.charts.forEach(chart => {
        if (chart != undefined && chart != null && chart['container'] && chart['container']['parentElement'] && chart['container']['parentElement']['id']) {
         let ele=document.getElementById(chart['container']['parentElement']['id']);
        if(ele){ let width = ele.clientWidth;
        let height = ele.clientHeight;
        chart.setSize(width, height);} 
        }
      });
    },0);
  }
  
  ngDoCheck(){
  if(this.globalService.csvUrl){
    let confirm:any = window.confirm("Press here to download CSV report!");
    if(!confirm){ 
      this.globalService.csvUrl="";
  }else{
    this.globalService.exportToExcel(this.globalService.csvUrl);
  }
}
  }
}
